import { AlternateDonationOptions } from "../enums";

export interface IDashPatientDonors {
    id: number,
    micrositeRecipientId: number,
    centerId: number,
    centerAlias: string,
    centerName: string,
    entryDomain: string,
    assignedCenterDomain: string,
    isRemoteDonationPreferred: boolean,
    donationId: number,
    firstName: string,
    lastName: string,
    ddRecipFirstName: string,
    ddRecipLastName: string,
    ddRecipBirthdate: string,
    ddAlternateDonationId: number,
    ddRelationshipToPatientId: number,
    abo: number,
    stateId: number,
    isReferral: boolean;
    connectToDonorAssignedFirstName: string,
    connectToDonorAssignedLastName: string,
    currentRegistrationStep: number,
    disposition: number,
    registrationDateTime: string,
    historyCompleteDateTime: string,
    closeLoopSurgeryDateTime: string,
    addressLine1: string,
    city: string,
    postalCode: string,
    genderId: number,
    email: string,
    birthDate: string,
    micrositeRecipient: string,
    micrositeRecipientCenterId: number,
    recipientCenterId: number,
    recipientCenterAlias: string,
    entryAssignedCenterMatch: boolean,
    donationType: string,
    source: string,
    ddRecipDob: string,
    ddAlternateDonationOptions: AlternateDonationOptions[],
    goodSamaritanDonation: boolean,
    ddRelationshipToPatient: string,
    aboType: string,
    state: string,
    connectToDonorAssignedInitials: string,
    currentWorkflowStatus: string,
    dispositionOrStatus: string,
    registrationDate: string,
    historyCompleteDate: string,
    closeLoopSurgeryDate: string,
    gender: string,
    birthDateFormat: string,
    calcAge: string,
    comments: string
}